"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Grid = _interopRequireDefault(require("./Grid"));

var _default = _Grid["default"];
exports["default"] = _default;